module.exports = __webpack_public_path__ + "img/45.93869227.jpg";